/* FilmFix: mark the nav link matching the current page as active */
(function () {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';

    document.querySelectorAll('.ff-nav__link[href]').forEach(function (link) {
        var linkPath = link.pathname.replace(/\/+$/, '') || '/';
        var active = linkPath === '/'
            ? path === '/'
            : path === linkPath || path.indexOf(linkPath + '/') === 0;
        if (active) {
            link.classList.add('is-active');
        }
    });
})();

/* FilmFix: STEUN FILMFIX dropdown toggle (desktop only; sub items are
   always visible on mobile) */
(function () {
    var desktop = window.matchMedia('(min-width: 768px)');
    var toggles = document.querySelectorAll('.ff-nav__toggle');

    toggles.forEach(function (toggle) {
        var parent = toggle.closest('.ff-has-children');
        if (!parent) return;

        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            if (!desktop.matches) return;
            var open = parent.classList.toggle('is-expanded');
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        document.addEventListener('click', function (e) {
            if (!parent.contains(e.target)) {
                parent.classList.remove('is-expanded');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });
    });
})();
